import { getterTypes, permissoes, routesNames, situacoes } from '@/core/constants'
import azDate from '@azinformatica/loki/src/filters/az-date'
import infoCabecalho from '@/core/store/default/infoCabecalho'

const SEM_ORGAO = 'Sem Órgão'

const montaInformacoes = (info) => {
	return getObjetoMontadoModoEdicaoPedido(info)
}

function getObjetoMontadoModoEdicaoPedido(info) {
	let cabecalho = []
	cabecalho.push(
		new infoCabecalho('Nº Pedido', { texto: info.numeroPedido ? info.numeroPedido : null }, 'numero', true),
	)
	cabecalho.push(
		new infoCabecalho('Criação', { texto: `${azDate(info.dataCadastro, 'DD/MM/YYYY')}` }, 'dataCadastro', true),
	)
	if (info.fornecedorUnicoDaAta)
		cabecalho.push(
			new infoCabecalho(
				'Fornecedor',
				{ texto: juntarRazaoSocialEDocumentoFornecedor(info.fornecedorUnicoDaAta) },
				'fornecedor',
			),
		)
	cabecalho.push(new infoCabecalho('Nº Ata', { texto: info.ataRegistroPreco?.numero }, 'numeroAta'))
	cabecalho.push(
		new infoCabecalho(
			'Órgão Gerenciador',
			{ texto: info.unidadeOrganizacional ? info.unidadeOrganizacional.sigla : SEM_ORGAO },
			'orgao',
		),
	)
	cabecalho.push(
		new infoCabecalho(
			'Órgão do Pedido',
			{texto: info.siglaOrgao ? info.siglaOrgao : '--'},
			'orgao',
		),
	)
	return cabecalho
}

function isRascunho(info) {
	return info.situacao === situacoes.PEDIDO.RASCUNHO.value
}

function montarAbasPedido(info) {
	let abas = []
	abas.push({
		titulo: 'Itens do Pedido',
		rota: { name: routesNames.PEDIDO.ACESSAR_ITENS_VIEW },
	})

	if (!isRascunho(info)) {
		abas.push({
			titulo: 'Documentos',
			rota: { name: routesNames.PEDIDO.ACESSAR_DOCUMENTOS_VIEW },
		})
		abas.push({
			titulo: 'Infrações e Sanções',
			rota: { name: routesNames.PEDIDO.ACESSAR_PENALIDADES_VIEW },
			permissao: permissoes.pedidoUtilizacaoPenalidadesListar,
		})
		abas.push({
			titulo: 'Ocorrências',
			tabDireita: true,
			rota: { name: routesNames.PEDIDO.ACESSAR_OCORRENCIAS_VIEW },
		})
		abas.push({
			titulo: 'Linha do tempo',
			tabDireita: true,
			rota: { name: routesNames.PEDIDO.ACESSAR_LINHA_DO_TEMPO_VIEW },
		})
	}
	return abas
}

function juntarRazaoSocialEDocumentoFornecedor(fornec) {
	return `${fornec.documento} - ${fornec.razaoSocial}`
}

export default {
	[getterTypes.PEDIDO.GET_INFORMACOES]: (state) => state.informacoesPedido,
	[getterTypes.PEDIDO.GET_PEDIDO_PARA_CABECALHO]: (state) => montaInformacoes(state.informacoesPedido),
	[getterTypes.PEDIDO.GET_HAS_AUTHORITY_FLUXO]: (state) => state.bpm.hasAutority,
	[getterTypes.PEDIDO.IS_PEDIDO_RASCUNHO]: (state) =>
		state.informacoesPedido.situacao === situacoes.PEDIDO.RASCUNHO.value,
	[getterTypes.PEDIDO.GET_ABAS_PEDIDO]: (state) => montarAbasPedido(state.informacoesPedido),
	[getterTypes.PEDIDO.GET_ETAPA_NOME]: (state) => state.bpm.etapaAtual.atividadeNome,
	[getterTypes.PEDIDO.GET_ETAPA_SITUACAO]: (state) => state.bpm.etapaAtual.atividadeSituacao,
	[getterTypes.PEDIDO.GET_ORGAO_PEDIDO]: (state) =>
		state.informacoesPedido.id ? state.informacoesPedido.idOrgao : 0,
	[getterTypes.PEDIDO.GET_REVISAO_PEDIDO]: (state) => state.revisao,
}
